// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"SY-z","subtitle":"TY-z","wrapper":"UY-z","leftArrow":"VY-z","rightArrow":"WY-z"};